var KTAppOptions = {
    "colors": {
        "state": {
            "brand": "#3d94fb",
            "light": "#ffffff",
            "dark": "#282a3c",
            "primary": "#5867dd",
            "success": "#34bfa3",
            "info": "#3d94fb",
            "warning": "#ffb822",
            "danger": "#fd27eb"
        },
        "base": {
            "label": ["#c5cbe3", "#a1a8c3", "#3d4465", "#3e4466"],
            "shape": ["#f0f3ff", "#d9dffa", "#afb4d4", "#646c9a"]
        }
    }
};

window.KTAppOptions = KTAppOptions;

import '../../vendor/panel/tools/webpack/vendors/global';
import './custom';
import '../../vendor/panel/tools/webpack/scripts';